import { WalletAddressesSaved } from 'BreetComponents';
import { useSavedWalletAddressApi, useUsdWithdrawRequestContext } from 'BreetHooks';
import { useCallback, useEffect, useRef } from 'react';

const DialogWithdrawUsdWalletAddressesSaved = () => {
	const { handleSelectAddress, resetWalletAddressProps, formDataContextProps, formStage } = useUsdWithdrawRequestContext();
	const { savedWalletAddresses, isLoadingSavedWalletAddresses } = useSavedWalletAddressApi();

	const onAddNewAddress = useCallback(() => {
		resetWalletAddressProps();
		formStage.navigator.goTo('add-wallet-address')();
	}, [resetWalletAddressProps, formStage]);

	const formData = formDataContextProps.hookFormProps.watch();
	const receiverAddress = formData.receiverAddress;
	const { isFormCompleted } = formDataContextProps;

	const autoSelectedRef = useRef<string | undefined>(undefined);

	useEffect(() => {
		if (!receiverAddress || isFormCompleted || autoSelectedRef.current === receiverAddress) return;

		const match = savedWalletAddresses.find((address) => address.address === receiverAddress);
		if (!match) return;

		autoSelectedRef.current = receiverAddress;
		handleSelectAddress(match).catch(console.error);
	}, [receiverAddress, isFormCompleted, savedWalletAddresses, handleSelectAddress]);

	// When exactly one address is saved, pre-select it so the user isn't asked to pick the only option.
	// Shares `autoSelectedRef` with the rehydrate effect above so the two never fire against each other.
	useEffect(() => {
		if (isLoadingSavedWalletAddresses || receiverAddress || isFormCompleted) return;
		if (savedWalletAddresses.length !== 1) return;

		const [onlyAddress] = savedWalletAddresses;
		if (autoSelectedRef.current === onlyAddress.address) return;

		autoSelectedRef.current = onlyAddress.address;
		handleSelectAddress(onlyAddress).catch(console.error);
	}, [isLoadingSavedWalletAddresses, savedWalletAddresses, receiverAddress, isFormCompleted, handleSelectAddress]);

	return (
		<WalletAddressesSaved
			onAddNewAddress={onAddNewAddress}
			onSelectAddress={handleSelectAddress}
			onManageAddress={formStage.navigator.goTo('manage-wallet-address')}
			selectedWalletAddress={formData.receiverAddress}
			onButtonClick={formStage.navigator.goTo('crypto-transaction-details')}
			isButtonDisabled={!formDataContextProps.isFormCompleted}
		/>
	);
};

export default DialogWithdrawUsdWalletAddressesSaved;
